module.exports = __webpack_public_path__ + "img/pix.266ff2b.svg";